import { render, staticRenderFns } from "./certifyDetail.vue?vue&type=template&id=35fd8f20&scoped=true"
import script from "./certifyDetail.vue?vue&type=script&lang=js"
export * from "./certifyDetail.vue?vue&type=script&lang=js"
import style0 from "./certifyDetail.vue?vue&type=style&index=0&id=35fd8f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd8f20",
  null
  
)

export default component.exports